//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconArrowZoomReverse(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M20 9.99994L22 7.99994H17.41L21.71 3.70994L20.29 2.28994L16 6.58994V1.99994L14 3.99994V9.99994H20Z" fill="currentColor" /><path d="M10 9.99999V3.99999L8.00001 1.99999V6.58999L3.71 2.28999L2.29 3.70999L6.59 7.99999H2L4.00001 9.99999H10Z" fill="currentColor" /><path d="M16 17.41L20.29 21.71L21.71 20.29L17.41 16H22L20 14H14V20L16 22V17.41Z" fill="currentColor" /><path d="M2.29022 20.29L3.71022 21.71L8.00021 17.41L8.00022 22L10.0002 20L10.0002 14H4.00022L2.00022 16H6.59022L2.29022 20.29Z" fill="currentColor" /></svg>;
}
export default IconArrowZoomReverse;